import { render, staticRenderFns } from "./payMethod.vue?vue&type=template&id=646e7bb8&scoped=true&"
import script from "./payMethod.vue?vue&type=script&lang=js&"
export * from "./payMethod.vue?vue&type=script&lang=js&"
import style0 from "./payMethod.vue?vue&type=style&index=0&id=646e7bb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e7bb8",
  null
  
)

export default component.exports